module.exports = __webpack_public_path__ + "static/images/chart.d701b45d7255b878a6255a405937c7a6.svg";